module.exports = __webpack_public_path__ + "img/ignitionOff.6227708e.svg";